<div class="background-base-0">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <div class="d-flex position-relative design-block" [ngClass]="{'justify-content-center': !isMobile}">
                <ng-container *ngTemplateOutlet="blockContent; context: {$implicit: visiblePosts}"></ng-container>
            </div>
        }
        @case (WebsiteMode.ReadOnly) {
            <div  class="d-flex position-relative" [ngClass]="{'justify-content-center': !isMobile}">
                <ng-container *ngTemplateOutlet="blockContent; context: {$implicit: visiblePosts}"></ng-container>
            </div>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent; context: {$implicit: visiblePosts}"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent let-posts>
    @if ((Scope.websiteMode === WebsiteMode.Preview || (Scope.websiteMode === WebsiteMode.ReadOnly && designBlockMode !== DesignBlockMode.Sidebar)) && allPostsLength !== null && allPostsLength === 0) {
        <div class="w-100 scss-blog-block-spacing py-5 scss-blog-empty-state">
            <lib-empty-state
                [emptyStateGraphic]="EmptyStateGraphic.News"
                [size]="isMobile? EmptyStateSize.Medium: EmptyStateSize.Large">
                <ng-container emptyStateText i18n="@@CommonBlogBlockEmptyStateText">No news or blog posts yet</ng-container>
                <ng-container emptyStateDescription i18n="@@CommonBlogBlockEmptyStateDescription">Posts published to your website from News & Blog Posts will appear here</ng-container>
                <ng-container emptyStateButton>
                    <lib-button
                        [suffixIcon]="Icon.Common.ChevronRight"
                        (clicked)="Scope.HandleBlockAction(websiteBlockData, WebsiteBlockAction.Edit)">
                        <ng-container label i18n="@@CommonBlogBlockGoToNewsEmptyStateButtonText">Go to News & Blog Posts</ng-container>
                    </lib-button>
                </ng-container>
            </lib-empty-state>
        </div>
    }
    @if (allPostsLength !== null && allPostsLength > 0) {
        <div class="w-100 d-flex flex-column py-2 px-4 px-sm-3 align-items-center gap-2 blog-block">
            @for (post of posts; track post.ID) {
                <div class="w-100 d-flex p-2  align-items-center justify-content-center">
                    <div class="d-flex flex-column  gap-4 w-100 align-items-center justify-content-center scss-spacing-text-media-block">
                        <div class="w-100 scss-background-blog-accent-line"></div>
                        <div class="position-relative w-100">
                            <div class="d-flex gap-2 position-absolute top-0 start-0">
                                <div [ngClass]="post | method: GetBackgroundColor" class="scss-blog-icon-container rounded" *ngLet="(post.Icon | postIcon) as postIcon">
                                    <lib-icon
                                        [icon]="postIcon.Icon">
                                    </lib-icon>
                                </div>
                                @if (post.Sticky) {
                                <div class="scss-blog-icon-container rounded background-info-100">
                                    <lib-icon  class="info-700" [icon]="Icon.Common.KeepOutline"></lib-icon>
                                </div>
                                }
                            </div>
                            <div class="w-100" [ngClass]="{'text-center': !isMobile, 'pt-5': isMobile}">
                                <h3 class="typography-semibold base-300 " >{{post.Title}}</h3>
                                <p class="typography-semibold base-200 typography-caption-large pt-3">{{post.Author}} - {{post.PublishDate | formatDate: 'long'}}</p>
                                @if (Scope.websiteMode !== WebsiteMode.ReadOnly ) {
                                    <lib-iframe [src]="post.BodyHTML!"></lib-iframe>
                                } @else {
                                    <p class="scss-iframe-read-only text-start" [innerHTML]="post.BodyHTML! | trustHtml"></p>
                                }

                            </div>

                        </div>
                    </div>
                </div>
            }
            @if (allPostsLength !== null && allPostsLength  > visiblePosts.length) {
                <div class="d-flex align-items-center justify-content-center w-100 px-3 py-2">
                    <lib-button
                        [kind]="ButtonKind.Link"
                        [suffixIcon]="Icon.Common.CaretDown"
                        (clicked)="GetNews()">
                        <ng-container label i18n="@@CommonShowMoreLabel">Show More</ng-container>
                    </lib-button>
                </div>
            }
        </div>
    }
</ng-template>
